// extracted by mini-css-extract-plugin
export default {"news":"Reviews_news__FCy3A","inner":"Reviews_inner__oIMvE"};